import { render, staticRenderFns } from "./FacilitiesUsers.vue?vue&type=template&id=4dd10ba6&scoped=true&"
import script from "./FacilitiesUsers.vue?vue&type=script&lang=ts&"
export * from "./FacilitiesUsers.vue?vue&type=script&lang=ts&"
import style0 from "./FacilitiesUsers.vue?vue&type=style&index=0&id=4dd10ba6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd10ba6",
  null
  
)

export default component.exports